export default {
    getOtp : (otp) => {
        otp = otp.trim();
        if(otp.match(/^[0-9]*$/) == null)
          otp = "";
        if(otp.length > 6)
          otp = otp.substring(0,6);
        return otp
    }
}